import React, { useCallback } from "react";
import { ListItem, ArrowRightIcon } from "@activecollab/components";
import PropTypes from "prop-types";
import { keyCodes } from "~/utils/key_codes.jsx";

export const Item = ({ id, name, onClick }) => {
  const handleClick = useCallback(() => {
    if (typeof onClick === "function") {
      onClick(id);
    }
  }, [id, onClick]);

  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === keyCodes.enter) {
        handleClick();
      }
    },
    [handleClick]
  );

  return (
    <ListItem
      key={`list-item-${id}`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      className="tw-pr-3"
      tabIndex={0}
    >
      <div className="tw-flex-1 tw-pr-2 tw-truncate">{name}</div>
      <ArrowRightIcon />
    </ListItem>
  );
};

Item.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};
